import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UIConfig, FeatureFlags } from "../api/models";
import { RootState } from "./appStore";

interface UIConfigState {
  uiConfig: UIConfig | null;
  featureFlags: FeatureFlags | null;
  lastFetched: number | null;
}

const initialState: UIConfigState = {
  uiConfig: null,
  featureFlags: null,
  lastFetched: null
};

export const uiConfigSlice = createSlice({
  name: "uiConfig",
  initialState,
  reducers: {
    setUIConfig: (state, action: PayloadAction<UIConfig>) => {
      state.uiConfig = action.payload;
      state.lastFetched = Date.now();
    },
    setFeatureFlags: (state, action: PayloadAction<FeatureFlags>) => {
      state.featureFlags = action.payload;
      state.lastFetched = Date.now();
    },
    setConfigAndFlags: (
      state,
      action: PayloadAction<{ uiConfig: UIConfig; featureFlags: FeatureFlags }>
    ) => {
      state.uiConfig = action.payload.uiConfig;
      state.featureFlags = action.payload.featureFlags;
      state.lastFetched = Date.now();
    },
    resetUIConfig: (state) => {
      state.uiConfig = null;
      state.featureFlags = null;
      state.lastFetched = null;
    }
  }
});

// Export actions
export const { setUIConfig, setFeatureFlags, setConfigAndFlags, resetUIConfig } = uiConfigSlice.actions;

// Export selectors
export const selectUIConfig = (state: RootState) => state.uiConfig.uiConfig;
export const selectFeatureFlags = (state: RootState) => state.uiConfig.featureFlags;
export const selectLastFetched = (state: RootState) => state.uiConfig.lastFetched;

export default uiConfigSlice.reducer;
